(function () {
  'use strict';

  class FormDuoRoutesCtrl {
    constructor(safetyService, ServiceVfiltro, FactoryVfiltro, Authenticator, blockUI, $stateParams, $state) {
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.stateParams = $stateParams;
      this.blockUI = blockUI;
      this.state = $state;

      this.duoRouteUUID = this.stateParams.duoRouteUUID;
      this.user = null;

      this.initialize();
    }

    initialize() {
      this.blockUI.start();
      return this.initFilter()
        .then(() => this.loadUser())
        .then(() => this.loadReact())
        .finally(() => {
          this.blockUI.reset();
          this.blockUI.stop();
        });
    }

    initFilter() {
      return this.serviceVfiltro.init(
        this.factoryVfiltro.get([])
      );
    }

    loadUser() {
      return this.authenticator.getUser()
        .then((user) => {
          this.user = user;
        });
    }

    loadReact() {
      const appName = 'safetyApp',
          componentName = './DuoRouteFormPageRoute',
          componentId = 'safety-duo-route-form',
          props = this.getReactProps();

      return this.safetyService
        .initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentName, componentId, props));
    }

    goBackToList() {
      this.state.go('root.duo-routes-cadastro');
    }

    getReactProps() {
      const props = {
        user: this.user,
        duoRouteUUID: this.duoRouteUUID,
        goBackToList: () => this.goBackToList()
      };

      if (this.stateParams.importFromVehicle) {
        props.importFromVehicle = this.stateParams.importFromVehicle;
      }
      if (this.stateParams.importStartDateTime) {
        props.importStartDateTime = this.stateParams.importStartDateTime;
      }
      if (this.stateParams.importEndDateTime) {
        props.importEndDateTime = this.stateParams.importEndDateTime;
      }

      return props;
    }
  }

  angular
    .module('duo-routes.cadastro-rotas')
    .controller('FormDuoRoutesCtrl', FormDuoRoutesCtrl);
}());
